import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ApiError } from "./lib/api";
import { SessionProvider } from "./app/session";
import { EventContextProvider } from "./app/eventContext";
import { ToastHost } from "./components/ui/primitives";
import { App } from "./App";
import "./styles/base.css";
import "./styles/components.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // Retrying a refusal just repeats it. Only transient failures are worth
        // a second attempt.
        if (error instanceof ApiError) {
          if (error.status >= 400 && error.status < 500) return false;
        }

        return failureCount < 2;
      },
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <SessionProvider>
          <EventContextProvider>
            <App />
            <ToastHost />
          </EventContextProvider>
        </SessionProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
